import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SelectPlanComponent } from "./core/client/pages/select-plan/select-plan.component";
import { HomeComponent } from "./core/client/pages/home/home.component";
import { HealthCheckComponent } from "./core/client/pages/health-check/health-check.component";
import { MdnComponent } from './core/client/pages/mdn/mdn.component';
import { MdnChangeInformationComponent } from './core/client/pages/select-plan/mdn-change-information/mdn-change-information.component';
import { TncComponent } from './core/client/pages/select-plan/tnc/tnc.component';
import { ReviewPlanComponent } from './core/client/pages/review-plan/review-plan.component';
import { OrderConfirmationComponent } from './core/client/pages/select-plan/order-confirmation/order-confirmation.component';
import { SignInComponent } from './core/client/pages/sign-in/sign-in.component';
import { TncResolver } from './core/client/pages/select-plan/tnc/tnc.resolver';
import { UniversalErrorComponent } from './core/client/pages/universal-error/universal-error.component';
import { SelectPlanResolver } from './core/client/pages/select-plan/select-plan.resolver';
import { ReviewPlanResolver } from './core/client/pages/review-plan/review-plan.resolver';
import { ExternalCode } from './shared/common/classes';
import { MultipleVehicleInfoComponent } from './core/client/pages/select-plan/multiple-vehicle-info/multiple-vehicle-info.component';

const routes: Routes = [
  { path: 'sign-in', component: SignInComponent },
  {
    path: 'account', children: [
      { path: 'mdn', component: MdnComponent },
      {
        path: 'select-plan', component: SelectPlanComponent, resolve: {
          data: SelectPlanResolver
        }
      },
      {
        path: 'multiple-vehicles-info', component: MultipleVehicleInfoComponent
      },
      {
        path: 'review-plan', component: ReviewPlanComponent, resolve: {
          nbs: ReviewPlanResolver
        }
      },
      { path: 'order-confirmation', component: OrderConfirmationComponent, canDeactivate: [(component: OrderConfirmationComponent) => false] },
      {
        path: 'tnc', component: TncComponent, resolve: {
          data: TncResolver
        }
      }
    ]
  },
  {
    path: 'main', children: [
      { path: 'home', component: HomeComponent },
      { path: 'health', component: HealthCheckComponent },
      {
        path: 'eligibility-error', component: UniversalErrorComponent, data: {
          title: "Your plan or your account is not eligible for Number Share-Vehicle.",
          code: ExternalCode.ACCOUNT_NOT_ELIGIBLE,
          customBlocks: ['custom-section-3']
        }
      },
      {
        path: 'session-error', component: UniversalErrorComponent, data: {
          title: "The session has expired.",
          description: "Please go back to the vehicle's mobile app and try again.",
          code: ExternalCode.SESSION_EXPIRED,
          customBlocks: ['custom-section-1']
        }
      },
      {
        path: 'invalid-clientid', component: UniversalErrorComponent, data: {
          title: 'Something went wrong while accessing this page',
          description: "Please go back to the vehicle's mobile app and try again",
          code: ExternalCode.LANDING_PAGE,
          customBlocks: ['custom-section-1']
        }
      },
      {
        path: 'order-error', component: UniversalErrorComponent, data: {
          title: 'Order error',
          description: "Please go back to the vehicle's mobile app and try again",
          code: ExternalCode.ACCOUNT_NOT_ELIGIBLE,
          customBlocks: ['custom-section-1']
        }
      },
      {
        path: 'nbs-error', component: UniversalErrorComponent, data: {
          title: 'There is no next bill summary for this product',
          description: "Please go back to the vehicle's mobile app and try again",
          code: ExternalCode.SUBSCRIPTION_ERROR,
          customBlocks: ['custom-section-1']
        }
      },
      {
        path: 'cancel-tnc-error', component: UniversalErrorComponent, data: {
          title: 'Terms and Conditions declined',
          customBlocks: ['custom-section-2'],
          code: ExternalCode.TNC_DECLINED,
        }
      },
      {
        path: 'invalid-account', component: UniversalErrorComponent, data: {
          description: "Please go back to the vehicle's mobile app and try again.",
          title: (() => {
            const urlParams = new URLSearchParams(window.location.search);
            const mdn = urlParams.get('mdn') || '';
            const mdnList = mdn.split(',').map(mdn => mdn.trim()).filter(mdn => mdn);
            return mdnList.length > 1 ? `${mdnList.join(', ')} were onboarded` : `${mdnList[0]} was onboarded`;
          })(),
          customBlocks: ['custom-section-1'],
          code: ExternalCode.INVALID_ACCOUNT
        }
      },
      {
        path: 'tnc-error', component: UniversalErrorComponent, data: {
          title: 'Unable to load Terms and Conditions',
          description: "Please go back to the vehicle's mobile app and try again",
          code: ExternalCode.ACCOUNT_NOT_ELIGIBLE,
          customBlocks: ['custom-section-1']
        }
      },
      {
        path: 'invalid-phone-number-error', component: UniversalErrorComponent, data: {
          title: "Number not found for Personal eSim activation",
          description: "Please return to your vehicle's mobile app and re-enter your telephone number.",
          code: ExternalCode.INVALID_PHONE_NUMBER,
          customBlocks: ['custom-section-1']
        }
      },
      {
        path: 'subcription-error', component: UniversalErrorComponent, data: {
          title: 'Something went wrong while subscribing',
          description: "Please go back to the vehicle's mobile app and try again",
          code: ExternalCode.SUBSCRIPTION_ERROR,
          customBlocks: ['custom-section-1']
        }
      },
      { path: 'mdn-change-info', component: MdnChangeInformationComponent },
    ]
  },
  { path: '**', redirectTo: '/main/home', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}


/*

account/mdn
account/select-plan
account/review-plan
account/order-confirmation
account/tnc
account/multiple-vehicles-info
main/home
main/eligibility-error
main/invalid-clientid
main/mdn-change-info
main/order-error
main/nbs-error
main/cancel-tnc-error
main/tnc-error
main/subcription-error
main/invalid-account
*/
